import React, { useState, useEffect } from "react";

type refType = React.MutableRefObject<HTMLDivElement | HTMLParagraphElement | null>

export function useOnScreen(ref: refType, threshold = 0.75): boolean {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = useState<boolean>(false);
  useEffect(() => {
    const refCurrent = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        setIntersecting(entry.isIntersecting);
      },
      {
        threshold
      }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if(refCurrent) {
        observer.unobserve(refCurrent);
      }
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount
  return isIntersecting;
}
